import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=d8e45f06&scoped=true"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"
import style0 from "./admin.vue?vue&type=style&index=0&id=d8e45f06&prod&lang=css"
import style1 from "./admin.vue?vue&type=style&index=1&id=d8e45f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e45f06",
  null
  
)

export default component.exports